/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowSquareOut(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M224,99.999a8.00053,8.00053,0,0,1-13.65723,5.65821L186,81.314l-36.37207,36.37159a8.00018,8.00018,0,1,1-11.31348-11.31446L174.68555,70,150.34277,45.65723A8.00066,8.00066,0,0,1,156,32h.001l59.99218.00781a8,8,0,0,1,7.999,7.999ZM184,136a8.00039,8.00039,0,0,0-8,8v64H48V80h64a8,8,0,0,0,0-16H48A16.01833,16.01833,0,0,0,32,80V208a16.01833,16.01833,0,0,0,16,16H176a16.01833,16.01833,0,0,0,16-16V144A8.00039,8.00039,0,0,0,184,136Z" />
    </Svg>
  );
}

export default ArrowSquareOut;
